import { Component, inject, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AboutService } from '../Services/aboutUs.service';
import { AboutUsModel } from '../Model/aboutUs.model';
import { SettingsModel } from '../../../shared/Model/setting.model';
import { CommonModule, SlicePipe } from '@angular/common';
import { SharedModule } from '../../../shared/Module/shared.module';
import { Subscription } from 'rxjs';
import { ProfilePageRoutingModule } from "../../../pages/my-account/profile-page-routing.module";
import { RouterModule } from '@angular/router';
import { AdsComponent } from "../../../shared/Componet/ads/ads.component";
import { AnnouncementService } from '../../../shared/service/announcement.service';
import { AdsService } from '../../../shared/service/ads.service';

@Component({
  selector: 'app-aboutus-home',
  imports: [TranslateModule, CommonModule, SharedModule, SlicePipe, ProfilePageRoutingModule, RouterModule, AdsComponent],
  templateUrl: './aboutus-home.component.html',
  styleUrl: './aboutus-home.component.css'
})
export class AboutusHomeComponent {

  aboutUs = signal<AboutUsModel[]>([]);
  settings = signal<SettingsModel[]>([])
  private subs = new Subscription();   // container for all subscriptions
  Announcements = signal<any[]>([])

  //constructor
  private aboutService = inject(AboutService);
  private AnnouncementService = inject(AnnouncementService)
  private AdsService = inject(AdsService)


  ngOnInit(): void {
    this.loadData();
    this.getAnnouncemnts()
    this.getSettings()
  }

  loadData() {
    const sub = this.aboutService.getAll().subscribe({
      next: (data) => {
        this.aboutUs.set(data.value)

      },
      error: (err) => {
        console.error('Error loading About us:', err);
      }
    })
    this.subs.add(sub);
  }

  getAnnouncemnts() {
    const sub = this.AnnouncementService.getDetectedAnnouncements({
      PageId: 6,
      SectionId: 6
    }).subscribe({
      next: (res: any) => {
        // this.Announcements.set(res.value)
        this.Announcements.set(this.AdsService.getDisplayedAds(res.value, 3));
      }
    })

    this.subs.add(sub);
  }

  getSettings() {
    const sub = this.aboutService.getAllSettings().subscribe({
      next: (data) => {
        this.settings.set(data.value)
      },
      error: (err) => {
        console.error('Error loading About us:', err);
      }
    })
    this.subs.add(sub);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();   // unsubscribe from all
  }
}

